export default __webpack_public_path__ + "static/3-ca6323fadebb5bac8f90e7f76f214094.webp";